import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import EmailIllustrationSrc from "images/email-illustration.png";
import { sendGeneric } from "api/mail";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center md:text-left`;
const Heading = tw(SectionHeading)`mt-4 font-black text-left text-3xl sm:text-4xl lg:text-5xl text-center md:text-left leading-tight`;
const Description = tw.p`mt-4 text-center md:text-left text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`

const Form = tw.form`mt-8 md:mt-10 text-sm flex flex-col max-w-sm mx-auto md:mx-0`
const Input = tw.input`mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-pbsGreen-500`
const Textarea = styled(Input).attrs({as: "textarea"})`
  ${tw`h-24`}
`

const SubmitButton = tw(PrimaryButtonBase)`inline-block mt-8`
const SuccessMessage = tw.div`text-green-700 bg-green-100 border border-green-300 rounded-md px-4 py-3 text-sm text-center mt-6`;
const FailMessage = tw.div`text-pbsOrange-700 bg-pbsOrange-100 border border-pbsOrange-300 rounded-md px-4 py-3 text-sm text-center mt-6`;


export default function ContactUsMain ({
  subheading = "Contact Us",
  heading = <>Feel free to <span tw="text-pbsOrange-500">get in touch</span><wbr/> with us.</>,
  description = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  submitButtonText = "Send",
  formAction = "#",
  formMethod = "get",
  textOnLeft = true,
}) {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState("");
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [failMessage, setFailMessage] = useState('');

  const sendContactEmail = (e) => {
    e.preventDefault(); // stop native form navigation
    sendGeneric({
      name,
      email,
      telephone,
      subject,
      message
    }).then(response => {
      console.log("Email sent successfully:", response);
      setName("");
      setEmail("");
      setTelephone("");
      setSubject("");
      setMessage("");
      if (response.success) {
        setSuccess(true);
        setFail(false);
      } else {
        setSuccess(false);
        setFail(true);
        setFailMessage(response.message || 'Failed to submit email. Please try again later.');
      }
    }).catch(error => {
      setSuccess(false);
      setFail(true);
      setFailMessage('Failed to submit application. Please try again later.');
      console.error("Error sending email:", error);
    });
  }

  return (
    <Container>
      <TwoColumn>
        <ImageColumn>
          <Image imageSrc={EmailIllustrationSrc} />
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            {/* {description && <Description>{description}</Description>} */}
            <Form action={formAction} method={formMethod} onSubmit={sendContactEmail}>
              <Input type="email" value={email} name="email" placeholder="Your Email Address" onChange={(e) => setEmail(e.target.value)} required />
              <Input type="text" value={name} name="name" placeholder="Full Name" onChange={(e) => setName(e.target.value)} required />
              <Input type="text" value={telephone} name="telephone" placeholder="Telephone" onChange={(e) => setTelephone(e.target.value)} required />
              <Input type="text" value={subject} name="subject" placeholder="Subject" onChange={(e) => setSubject(e.target.value)} required />
              <Textarea name="message" value={message} placeholder="Your Message Here" onChange={(e) => setMessage(e.target.value)} required />
              <SubmitButton type="submit">{submitButtonText}</SubmitButton>
              {success && (
                <SuccessMessage>
                  🎉 Your email has been submitted successfully!
                </SuccessMessage>
              )}
              {fail && (
                <FailMessage>
                  {('❌ ' + failMessage) || '❌ Failed to submit email. Please try again later.'}
                </FailMessage>
              )}
            </Form>
          </TextContent>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
